import { styled } from '@mui/material/styles'
import { Grid } from '@mui/material'

export const Wrapper = styled(Grid)(props => `
    width:100%;
    height:auto;
`)
